import { translationStatistics_da_part1 } from "./translationStatistics.da.part1";
import { translationStatistics_da_hours } from "./translationStatistics.da.hours";
import { defineTranslationTree } from "./translationTypes";
import { translationStatistics_da_part2 } from "./translationStatistics.da.part2";
import { translationStatistics_da_part3 } from "./translationStatistics.da.part3";
import { translationStatistics_da_part4 } from "./translationStatistics.da.part4";

export const translationStatistics_da = defineTranslationTree({
  aiClickRate: "Klik på produkter og links",
  aiClickRateTooltip:
    "Samtaler med et klik divideret med samtaler, der har fået vist et AI-link eller en produkthandling. Hver samtale tæller én gang. Vist betyder gengivet i chatten, også uden for det synlige område.",
  hyperlinkClickRate: "Hyperlinks",
  productClickRate: "Produktkort",
  clickRateCounts: "{clicked} af {eligible} samtaler",
  clickRateViewBreakdown: "Se klikrater for hyperlinks og produkter",
  clickRateBreakdownHint:
    "Hver type beregnes ud fra de samtaler, der har fået vist typen. En samtale kan klikke på begge typer, så raterne kan ikke lægges sammen. Produktklik omfatter åbning af produkt, tilføjelse til kurv og ønskeliste; opfølgende spørgsmål tæller ikke med.",
  clickRateTrackingNote:
    "Baseret på registrerede visninger siden klikmålingen blev lanceret. Historiske samtaler uden registrerede visninger er ikke medregnet.",
  ...translationStatistics_da_part1,
  ...translationStatistics_da_part2,
  ...translationStatistics_da_part3,
  ...translationStatistics_da_part4,
  ...translationStatistics_da_hours,
});
